import { createGlobalState } from '@vueuse/core';
import { ref } from 'vue';
import type { LifecycleStatusDefinitionType } from '~/services/intelligentInboxSettings/intelligentInboxSettingsClient.types';
import { useIntelligentInboxSettings } from '~/composables/useIntelligentInboxSettings';
import { useToasted } from '~/composables/useToasted';
import { catchRequestError } from '~/utils/request';

export const useLifecycleStatusDefinitions = createGlobalState(() => {
    const toasted = useToasted();
    const { getSettings } = useIntelligentInboxSettings();
    const definitions = ref<LifecycleStatusDefinitionType[] | undefined>(undefined);
    const loading = ref(false);

    const fetchDefinitions = async (): Promise<void> => {
        if (loading.value || definitions.value !== undefined) {
            return;
        }
        loading.value = true;
        try {
            const response = await getSettings();
            definitions.value = response.data.lifecycle_status_definitions;
        } catch (err) {
            toasted.error(catchRequestError(err));
            definitions.value = [];
        } finally {
            loading.value = false;
        }
    };

    return { definitions, loading, fetchDefinitions };
});
